import { Route, BrowserRouter, Routes, useNavigate } from "react-router-dom";

import { DeviceProvider } from "~/Context/DeviceContext";
import SettingsContext, { SettingsProvider } from "~/Context/SettingsContext";
import { ImportContext, ImportProvider } from "~/Context/ImportContext";
import { FilteredTracksProvider } from "~/Context/FilteredTracksContext";
import { MapGuiProvider } from "~/Context/MapGuiContext";
import { GuiProvider } from "~/Context/GuiContext";
import { buildTrackData } from "~/js/Views/Track/Parser/utilities/buildTrackData";

import AppLayout from "~/js/AppLayout";
import React, { Suspense, useContext, useEffect, useState } from "react";
import i18next from "~/js/locale/i18n";

const OpensourceModal = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true */ "~/js/Views/Settings/Opensource/OpensourceModal"
    ),
);

const ChangelogModal = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true */ "~/js/Views/Settings/Changelog/ChangelogModal"
    ),
);

const OverlaysWrapper = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true */ "~/js/Views/Track/Overlays/OverlaysWrapper"
    ),
);
const TracksModal = React.lazy(
  () =>
    import(/* webpackPrefetch: true */ "~/js/Views/TracksManager/TracksModal"),
);
const TrackViewer = React.lazy(
  () =>
    import(/* webpackPrefetch: true */ "~/js/Views/Track/Parser/TrackViewer"),
);

const AppSettings = React.lazy(
  () => import(/* webpackPrefetch: true */ "./Views/Settings/AppSettings"),
);

// remove app loader from dom
document.getElementById("appLoader").remove();
// end remove app loader from dom

import { LevelProvider } from "Trackalyze/context/LevelContext";
import { IconProvider } from "Trackalyze/context/IconContext";
import { resolveIcon } from "~/js/config/iconMapping";
import FilterWrapperPortrait from "./Views/TracksManager/Filter/FilterWrapperPortrait";
import SortWrapperPortrait from "./Views/TracksManager/Sort/SortWrapperPortrait";
import GroupsEditWrapper from "./Views/TracksManager/GroupsEditWrapper";
import GUI from "./Views/GUI/GUI";

const AppContent = ({ children }) => {
  const { track } = useContext(ImportContext);
  const { profile } = useContext(SettingsContext);
  const navigate = useNavigate();

  const [trackData, setTrackData] = useState(null);
  const [isReversed, setIsReversed] = useState(false);

  // *** reset reversed state on track change ***
  useEffect(() => {
    // setIsReversed(false);
  }, [track]);

  // *** build track data ***
  useEffect(() => {
    if (track !== null) {
      const data = buildTrackData(track, profile, isReversed);
      console.log("data", data);
      setTrackData(data);
    } else {
      setTrackData(null);
    }
  }, [track, profile, isReversed]);

  return (
    <MapGuiProvider
      trackData={trackData}
      isReversed={isReversed}
      toggleReverse={() => setIsReversed(!isReversed)}
    >
      <GuiProvider>{children}</GuiProvider>
    </MapGuiProvider>
  );
};

export const App = () => {
  return (
    <BrowserRouter>
      <DeviceProvider>
        <AppLayout>
          <IconProvider resolver={resolveIcon}>
            <LevelProvider>
              <ImportProvider>
                <SettingsProvider>
                  <FilteredTracksProvider>
                    <AppContent>
                      <Suspense fallback={<></>}>
                        <Routes>
                          <Route path="/*" element={<TrackViewer />}>
                            <Route path="tracks" element={<TracksModal />}>
                              <Route
                                path="sort"
                                element={<SortWrapperPortrait />}
                              />
                              <Route
                                path="filter"
                                element={<FilterWrapperPortrait />}
                              />
                              <Route path="delete" element={<></>} />
                              <Route
                                path="groups"
                                element={<GroupsEditWrapper />}
                              />
                            </Route>
                            <Route
                              path="groups"
                              element={<GroupsEditWrapper />}
                            />
                            <Route
                              path="overlays"
                              element={<OverlaysWrapper />}
                            />
                            <Route
                              path="changelog"
                              element={<ChangelogModal />}
                            />
                          </Route>
                          <Route path="settings" element={<AppSettings />}>
                            <Route
                              path="opensource"
                              element={<OpensourceModal />}
                            />
                            <Route
                              path="changelog"
                              element={<ChangelogModal />}
                            />
                          </Route>
                          <Route path="gui" element={<GUI />} />
                        </Routes>
                      </Suspense>
                    </AppContent>
                  </FilteredTracksProvider>
                </SettingsProvider>
              </ImportProvider>
            </LevelProvider>
          </IconProvider>
        </AppLayout>
      </DeviceProvider>
    </BrowserRouter>
  );
};
